<template>
  <div style="position: relative;">
    <el-form ref="yearDurationStatisticsFilter" :model="yearDurationStatistics" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="年度" prop="formFilter.year">
          <el-date-picker class="filter-item" v-model="yearDurationStatistics.formFilter.year" :clearable="true"
            format="yyyy"
            value-format="yyyy"
            type="year" align="left"
            placeholder=""
          />
        </el-form-item>
        <el-form-item label="专家" prop="formFilter.specialistName">
          <el-input class="filter-item" v-model="yearDurationStatistics.formFilter.specialistName"
            :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="类型" prop="formFilter.specialistType">
          <el-select class="filter-item" v-model="yearDurationStatistics.formFilter.specialistType" :clearable="true" filterable
                     placeholder="" :loading="yearDurationStatistics.specialistType.impl.loading"
                     @visible-change="yearDurationStatistics.specialistType.impl.onVisibleChange"
          >
            <el-option v-for="item in yearDurationStatistics.specialistType.impl.dropdownList" :key="item.id"
                       :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetYearDurationStatistics">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshYearDurationStatistics(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('yearDurationStatistics:yearDurationStatistics:export')"
          @click="onExportClick()">
          导出
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="onlineDurationRecord" :data="yearDurationStatistics.OnlineDurationRecord.impl.dataList" :size="defaultFormItemSize" @sort-change="yearDurationStatistics.OnlineDurationRecord.impl.onSortChange"
          header-cell-class-name="table-header-gray"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="yearDurationStatistics.OnlineDurationRecord.impl.getTableIndex" />
          <el-table-column label="专家名称" prop="specialistName">
          </el-table-column>
          <el-table-column label="类型" prop="specialistType">
          </el-table-column>
          <el-table-column label="时长" prop="duration">
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="yearDurationStatistics.OnlineDurationRecord.impl.totalCount"
            :current-page="yearDurationStatistics.OnlineDurationRecord.impl.currentPage"
            :page-size="yearDurationStatistics.OnlineDurationRecord.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="yearDurationStatistics.OnlineDurationRecord.impl.onCurrentPageChange"
            @size-change="yearDurationStatistics.OnlineDurationRecord.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { OnlineDurationRecordController, DictionaryController } from '@/api';

export default {
  name: 'yearDurationStatistics',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      yearDurationStatistics: {
        formFilter: {
          year: undefined,
          specialistType: undefined,
          specialistName: undefined
        },
        formFilterCopy: {
          year: undefined,
          specialistType: undefined,
          specialistName: undefined
        },
        specialistType: {
          impl: new DropdownWidget(this.loadSpecialistTypeDropdownList)
        },
        OnlineDurationRecord: {
          impl: new TableWidget(this.loadOnlineDurationRecordWidgetData, this.loadOnlineDurationRecordVerify, true, false)
        },
        isInit: false
      }
    }
  },
  methods: {
    loadSpecialistTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSpecialistTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    onResetYearDurationStatistics () {
      this.$refs.yearDurationStatisticsFilter.resetFields();
      this.refreshYearDurationStatistics(true);
    },
    /**
     * 在线时长记录数据获取函数，返回Promise
     */
    loadOnlineDurationRecordWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        onlineDurationRecordDtoFilter: {
          specialistName: this.yearDurationStatistics.formFilterCopy.specialistName,
          specialistType: this.yearDurationStatistics.formFilterCopy.specialistType,
          year: this.yearDurationStatistics.formFilterCopy.year
        }
      }
      return new Promise((resolve, reject) => {
        OnlineDurationRecordController.yearList(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 在线时长记录数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadOnlineDurationRecordVerify () {
      this.yearDurationStatistics.formFilterCopy.specialistName = this.yearDurationStatistics.formFilter.specialistName;
      this.yearDurationStatistics.formFilterCopy.specialistType = this.yearDurationStatistics.formFilter.specialistType;
      this.yearDurationStatistics.formFilterCopy.year = this.yearDurationStatistics.formFilter.year;
      return true;
    },
    /**
     * 更新全年时长统计表
     */
    refreshYearDurationStatistics (reloadData = false) {
      if (reloadData) {
        this.yearDurationStatistics.OnlineDurationRecord.impl.refreshTable(true, 1);
      } else {
        this.yearDurationStatistics.OnlineDurationRecord.impl.refreshTable();
      }
      if (!this.yearDurationStatistics.isInit) {
        // 初始化下拉数据
      }
      this.yearDurationStatistics.isInit = true;
    },
    /**
     * 导出
     */
    onExportClick () {
      let params = {
        onlineDurationRecordDtoFilter: {
          specialistName: this.yearDurationStatistics.formFilterCopy.specialistName,
          specialistType: this.yearDurationStatistics.formFilterCopy.specialistType,
          year: this.yearDurationStatistics.formFilterCopy.year
        }
      };

      OnlineDurationRecordController.exportYear(this, params, '全年在线时长统计.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    onResume () {
      this.refreshYearDurationStatistics();
    },
    initFormData () {
    },
    formInit () {
      this.refreshYearDurationStatistics();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
